import PortfolioHistoryTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableControls';
import PortfolioHistoryTableMarketFilter from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableMarketFilter';

interface Props {
	marketFilter: string;
	handleMarketFilterChange: (marketFilter: string) => void;
}

export default function PortfolioHistoryPositionsTableControls({
	marketFilter,
	handleMarketFilterChange,
}: Props) {
	return (
		<PortfolioHistoryTableControls noExportButton>
			<PortfolioHistoryTableMarketFilter
				marketType="perp"
				marketFilter={marketFilter}
				handleMarketFilterChange={handleMarketFilterChange}
				id="portfolio-history-positions-table-market-filter"
			/>
		</PortfolioHistoryTableControls>
	);
}
